import Store from './../store'
// https://github.com/niklasvh/html2canvas/issues/1064#issuecomment-732241897
// import html2canvas from '@/lib/html2canvas/html2canvas'

function getStyle(data, namingRule = 'kebab') {
  const style = Object.assign({}, data)
  // top、left、position放在外面一层的包裹元素上
  delete style.top
  delete style.left
  delete style.position
  delete style.rotate
  delete style.transform

  const keyNeedPX = [
    'width',
    'height',
    'border-width',
    'border-radius',
    'top',
    'right',
    'bottom',
    'left',
    'font-size',
    'line-height',
    '-webkit-text-stroke-width'
  ]
  const keyNeedEm = ['letter-spacing']
  Object.keys(style).forEach(key => {
    if (keyNeedPX.includes(key) && isNumber(style[key])) {
      if (String(style[key]).indexOf('%') === -1) {
        style[key] = style[key] + 'px'
      }
    }
    if (keyNeedEm.includes(key) && isNumber(style[key])) {
      if (String(style[key]).indexOf('%') === -1) {
        style[key] = style[key] + 'em'
      }
    }
    if (namingRule === 'camel') {
      // 使用驼峰命名
      const camelKey = toCamel(key)
      if (key !== camelKey) {
        style[camelKey] = style[key]
        delete style[key]
      }
    }
  })

  if (style['background-image']) {
    style['background-image'] = `url(${style['background-image']})`
  }

  delete style['-webkit-text-stroke-width']
  if (['#ffffff', '#fff', 'rgb(255, 255, 255)', 'rgba(255, 255, 255, 1)'].includes(style['-webkit-text-fill-color'])) {
    style['-webkit-text-fill-color'] = style['-webkit-text-stroke-color']
  }

  return style
}

function getBoxShadow(shadow) {
  return `${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.color}`
}

function isNumber(data) {
  return !Number.isNaN(parseInt(data, 10))
}

// 转驼峰命名
function toCamel(str) {
  return str.replace(/([^-])(?:-+([^-]))/g, function($0, $1, $2) {
    return $1 + $2.toUpperCase()
  })
}

function getImgStyle(module) {
  const fullSize = { ...module.fullSize }
  const display = { ...module.display }
  const style = {}
  style.width = fullSize.width
  style.height = fullSize.height
  style.left = -display.left
  style.top = -display.top

  style.position = 'absolute'
  const keyNeedPX = ['width', 'height', 'top', 'right', 'bottom', 'left']
  Object.keys(style).forEach(key => {
    if (keyNeedPX.includes(key) && isNumber(style[key])) {
      style[key] = style[key] + 'px'
    }
  })

  return style
}

function fixTemplateData(data) {
  if (data.bg_apply_all === undefined) {
    data.bg_apply_all = false
  }

  fixPagesField(data)
  fixWidgetsField(data)
}

function fixPagesField(data) {
  data.pages = data.pages || {}
  const pages = data.pages
  if (!isNumber(pages.opacity)) {
    pages.opacity = 1
  }
}

function fixWidgetsField(data) {
  data.pages.cmps = data.pages.cmps || []
  data.pages.cmps.forEach(widget => {
    if (isObject(widget.animation)) {
      widget.animation = [widget.animation]
    }
    if (!widget.animation) {
      widget.animation = []
    }
    // 有一些历史数据有这样的： index: "none" 无动画，过滤掉
    if (widget.animation && widget.animation.filter) {
      widget.animation = widget.animation.filter(ani => {
        return ani?.name
      })
    }

    if (isObject(widget.trigger)) {
      widget.trigger = [widget.trigger]
    }
  })
}

function fixColor(color) {
  if (color && color.indexOf('#') >= 0 && color.length === 4) {
    color = color.substr(1, 3)
    color = color
      .split('')
      .map(c => c.concat(c))
      .join('') // console.log({color})
  }
  return '#' + color
}

function create_id(length = 8) {
  return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36)
}

function getQueryString() {
  const url = location.href
  const theRequest = {}
  let strs = []
  if (url.indexOf('?') !== -1) {
    var str = url.split('?')[1]
    strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]'
}

function insert_font_face(fontName) {
  const font_name = fontName
  if (font_name.indexOf('font-') < 0) {
    // 老数据,普通字体
    return
  }
  if ($(`style.${fontName}`).length) {
    // 已经有这个字体了
    return
  }
  const font_class = fontName
  const font = Store.state.options.fontFamily.find(f => f.value === fontName)
  if (!font) {
    return
  }
  if ($(`.${font_class}`).length) {
    return
  }
  const el = `<style class="custom-font ${font_name}">
      @font-face {
        font-family: "${font_class}";
        src: ${getFontUrl(font)};
      }
    </style>`
  $('head').append(el)
}

function getFontUrl(font) {
  const url = 'https://staticjs.71360.com/static/suichuan/fonts/'
  const fontFile = font.indexNameEn
  let fontName = fontFile.split('.')
  fontName[fontName.length - 1] = ''
  fontName = fontName.join('.')
  if (font.hasWoffFile) {
    return `url("${url}${fontName + 'woff2'}") format('woff2'), url("${fontName + 'woff'}") format('woff')`
  } else {
    return `url("${url}${fontFile}")`
  }
}

// 图片地址判断
function src_has_gif(src) {
  let end = ''
  if (src && src.indexOf('.gif') < 0) {
    if (src.indexOf('?') >= 0) {
      end = src + '&ct=webp'
    } else {
      end = src + '?ct=webp'
    }
  } else {
    end = src
  }
  return end
}

function getFilterCss(filter) {
  if (!filter) {
    return
  }
  const brightness = 'brightness(' + (100 + filter.brightness) / 100 + ')'
  const contrast = 'contrast(' + (filter.contrast + 100) + '%)'
  const saturate = 'saturate(' + (filter.saturate + 100) + '%)'
  const hueRotate = 'hue-rotate(' + 3.6 * filter.hueRotate + 'deg)'
  const blur = 'blur(' + Math.abs(filter.blur) / 10 + 'px)'
  return brightness + ' ' + contrast + ' ' + saturate + ' ' + hueRotate + ' ' + blur
}

function createPage() {
  const page = {
    id: create_id(8),
    row: 0,
    col: 0,
    in: null,
    out: null,
    bgcol: null,
    selectBgType: '1',
    bgimage: '',
    bgserver: '',
    bgleft: 0,
    bgpositionx: 50,
    bgtop: 0,
    opacity: 1,
    cmps: []
  }
  return page
}

function createLongPage() {
  const page = {
    id: create_id(8),
    row: 0,
    col: 0,
    in: null,
    out: null,
    bgcol: null,
    selectBgType: '1',
    bgimage: '',
    bgserver: '',
    bgleft: 0,
    bgpositionx: 50,
    bgtop: 0,
    height: Store.state.body.data.height,
    long_page: true,
    opacity: 1,
    cmps: []
  }
  return page
}

function formatTime(time) {
  time = new Date(time)
  const year = time.getFullYear()
  const month = time.getMonth() + 1
  const date = time.getDate()
  const hour = time.getHours()
  const min = time.getMinutes()
  const second = time.getSeconds()
  return getTimeString([year, month, date], '-') + ' ' + getTimeString([hour, min, second], ':')
}

function getTimeString(list, separator) {
  return list.map(item => (item < 10 ? '0' + String(item) : item)).join(separator)
}

function fixImgSize(url, module) {
  loadImg(url, img => {
    // module.style.height = img.naturalHeight * (module.style.width / img.naturalWidth)
  })
}

function loadImg(url, cb) {
  const img = new Image()
  img.src = url
  img.onload = function() {
    cb && cb(img)
  }
}

function getCoverImg(zoom = 1) {
  // const El = document.querySelector(".page_list .page_item .item_preview .layout_body_wrapper");
//   const El = document.querySelector('.page_list_wrapper .first-page .first-page__preview .layout_body_wrapper')

//   return html2canvas(El, {
//     scale: 2,
//     useCORS: true,
//     allowTaint: true,
//     imageTimeout: 5000,
//     onclone(doc) {
//       const firstPage = doc.querySelector('.page_list_wrapper .first-page')
//       firstPage.style.display = 'block'
//       firstPage.style.transform = `scale(${zoom})`
//     }
//   })
}

function createScale() { 
  const flowChartFrame = document.querySelector('.flowChartFrame')
  const w = flowChartFrame.offsetWidth;
  const scale = Store.state.offline_atlas.aerialViewWidth / w;
  return scale;

}

function createTimeString() { 
  const step = 10 * 60 * 1000
  let date = new Date();
  date = new Date(Math.ceil(date / step) * step)
  let tenMinutesLater = new Date(date.getTime() + 10 * 60 * 1000);

  const formatter = new Intl.DateTimeFormat('en-US', {
    hour12: false, // 24小时制
    hour: '2-digit',
    minute: '2-digit'
  });
  
  const obj = {
    start:formatter.format(date),
    end:formatter.format(tenMinutesLater),
  }
  return obj;
}

export default {
  getStyle,
  getBoxShadow,
  getImgStyle,
  fixTemplateData,
  fixPagesField,
  fixColor,
  create_id,
  getQueryString,
  isObject,
  isNumber,
  insert_font_face,
  src_has_gif,
  getFilterCss,
  createPage,
  createLongPage,
  formatTime,
  fixImgSize,
  getCoverImg,
  createScale,
  createTimeString
}
